import { useRef, useEffect, useState } from 'react';
import './HorizonSection.css';

// ── Mobile scroll-highlight hook ──────────────────────────────────────────────
function useMobileInView() {
  const ref = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    if (!window.matchMedia('(max-width: 767px)').matches) return;

    const observer = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { rootMargin: '-25% 0px -25% 0px', threshold: 0 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return [ref, inView];
}

function HorizonCard({ p }) {
  const [cardRef, mobileInView] = useMobileInView();
  return (
    <div
      ref={cardRef}
      className={`hz-card${mobileInView ? ' hz-card--in-view' : ''}`}
    >
      <div className="hz-card-top">
        <span className="hz-icon" aria-hidden="true">{p.icon}</span>
        <span className="hz-badge">{p.badge}</span>
      </div>
      <h3 className="hz-card-title">{p.title}</h3>
      {p.lines.map((line, i) => (
        <p key={i} className="hz-card-line">{line}</p>
      ))}
    </div>
  );
}

const PILLARS = [
  {
    icon: '🏆',
    badge: 'Coming Soon',
    title: 'Elite Leagues & Tournaments',
    lines: [
      'Pro-tier leagues with real prize pools and a ruthless promotion and relegation system — the higher you climb, the bigger the rewards.',
      'Carnival tournaments, 1v1 knockout brackets, and multi-week structured competitions aligned with Australia\'s biggest race meetings.',
    ],
  },
  {
    icon: '📊',
    badge: 'Coming Soon',
    title: 'Advanced Analytics & Rankings',
    lines: [
      'A global SS-Elo rating system that ranks the sharpest minds in the game based on true skill — not luck.',
      'Proprietary quantitative runner ratings designed to expose real market value and give you a critical edge in the draft.',
    ],
  },
  {
    icon: '👥',
    badge: 'Coming Soon',
    title: 'Social Syndicates & Team Play',
    lines: [
      'Private leaderboards to challenge your mates in custom Showdowns. Co-op team tournaments where syndicates compete against rival factions.',
      'Live in-game chat to talk tactics, celebrate winners, and sweat out the photo finishes together.',
    ],
  },
  {
    icon: '🐴',
    badge: 'Coming Soon',
    title: 'Real-World Racing Integration',
    lines: [
      'Bridging the gap between fantasy and reality. Exclusive partnerships with trainers, bloodstock syndicators, and sales companies.',
      'Transition from virtual equity to purchasing real-world shares in stable runners — directly through the platform.',
    ],
  },
];

export default function HorizonSection() {
  return (
    <section className="hz-section">
      <div className="hz-inner">

        <div className="hz-header">
          <span className="hz-eyebrow">ROADMAP</span>
          <h2 className="hz-title">On the Horizon</h2>
          <p className="hz-sub">
            Syndicator Showdown is evolving fast. Here's what's coming for the sharpest
            fantasy racing platform in Australia.
          </p>
        </div>

        <div className="hz-grid">
          {PILLARS.map((p) => (
            <HorizonCard key={p.title} p={p} />
          ))}
        </div>

        <p className="hz-cta-note">
          Register your free account now and be first in line when these features launch.
        </p>

      </div>
    </section>
  );
}
